// extracted by mini-css-extract-plugin
export default {"container":"DateInput_container__8onXY","dateInput":"DateInput_dateInput__AaN+C"};